/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Missmatchdefectp22Inputs */



/**
* | output |
* | --- |
* | "Mismatch fault (right/bottom pump)" |
*
* @param {Ahu_History_Key_Missmatchdefectp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_missmatchdefectp22 = /** @type {((inputs?: Ahu_History_Key_Missmatchdefectp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Missmatchdefectp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mismatch fault (right/bottom pump)")
	return /** @type {LocalizedString} */ ("Défaut de discordance pompe droite/basse")
});
export { ahu_history_key_missmatchdefectp22 as "ahu_history_key_missmatchDefectP2" }